import { useMemo } from 'react';
import type { PdfComponentHeadingI } from '../typed';

const TermsAndConditionsRenderHeading: React.FunctionComponent<PdfComponentHeadingI> =
  function ({ title, alignment = 'left' }) {
    const className = useMemo(
      () =>
        [
          'text-18-22-em md:text-20-24-em my-1 w-full mx-auto',
          alignment === 'left' ? 'text-left' : undefined,
          alignment === 'right' ? 'text-right' : undefined,
          alignment === 'center' ? 'text-center' : undefined,
        ]
          .filter(Boolean)
          .join(' '),
      [alignment],
    );
    return <span className={className}>{title}</span>;
  };

export default TermsAndConditionsRenderHeading;
